export class ActionConstant {
  static actionSaveOrderMoneyTmp: string = "saveOrderMoneyTmp";
  static actionSaveOrder: string = "saveOrder";
  static ACTION_DELETE_PRODUCT_UNAVAILABLE = "action_delete_product_unavailable";
  static actionConfirmLogined: string = "action_confirm_logined";

  static ACTION_CONFIRM_DELETE_PAGE_WISH_LIST : string = "action_confirm_delete_page_wish_list";
  static ACTION_CONFIRM_DELETE_ALL_WISH_LIST : string = "action_confirm_delete_all_wish_list";
  static ACTION_SAVE_REVIEW_SUCCESS : string = "action_save_review_success";
  static ACTION_ORDER_SUCCESSFUL = "action_order_successful";
  static ACTION_CLOSE_MESSAGE: string = "action_close_message";
}
